/**
 * This is a provider, so no story makes sense for this component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponentWithChildren } from 'src/utils/types';
import { MaybeLoanID } from 'src/common/types';
import { useDatadogCurrentUserManagerState } from './hooks/useDatadogCurrentUserManagerState';

export const DatadogCurrentUserManager: FunctionComponentWithChildren<{ loanID?: MaybeLoanID }> = ({
    children,
    loanID,
}) => {
    useDatadogCurrentUserManagerState(loanID);

    return <>{children}</>;
};
